import React, { useState, useEffect } from "react";
import { object, array, string } from "prop-types";
import { connect } from "react-redux";
import get from "lodash/get";

import Organism1 from "./Organism1";
import Organism2 from "./Organism2";
import WideStoryCard from "../../molecules/WideStoryCard";
import CollectionTitleWithArrow from "../../atoms/CollectionTitleWithArrow";
import CustomStoryCard4 from "../../molecules/CustomStoryCard4";
import { getSlug } from "../../utils/utils";
import DfpAd from "../../dfp-ad";
import Headline from "../../atoms/Headline";
import { Link } from "@quintype/components";

import "./fourCollection12Stories1Ad.m.css";

const FourCollection12Stories1Ad = ({ collection, sections, publisherAttributes, domainSlug }) => {
  const [isTab, setIsTab] = useState(false);
  const collectionSlug = getSlug(collection, sections, domainSlug);
  const subCollections = collection.items
    .filter(collectionObj => collectionObj.type === "collection" && collectionObj.items && collectionObj.items.length)
    .slice(0, 4);
  const columnCollections = subCollections.slice(1, 4);
  const fourthCollection = subCollections.length > 0 ? subCollections[0] : null;
  const storyList =
    fourthCollection && fourthCollection.items && fourthCollection.items.length > 0
      ? fourthCollection.items.filter(item => item.type === "story").slice(0, 6)
      : null;
  const showCollectionName = get(collection, ["associated-metadata", "show_collection_name_website"], null);
  const showSubCollectionName = get(fourthCollection, ["associated-metadata", "show_collection_name_website"], null);
  const fourthCollectionSlug = getSlug(fourthCollection, sections, domainSlug);

  if (!storyList) {
    return null;
  }

  useEffect(() => {
    if (global.deviceWidth > 875 && global.deviceWidth < 1264) {
      setIsTab(!isTab);
    }
  }, []);

  return (
    <div styleName="base" className="four-collection-12stories-1ad" data-testid="12-stories">
      {showCollectionName && (
        <CollectionTitleWithArrow
          collectionSlug={collectionSlug}
          collectionName={collection.name}
          headlineClassName="collection-name-arrow"
          updatedFont={true}
        />
      )}
      <div styleName={columnCollections.length > 0 ? "collection-container" : ""}>
        {columnCollections && columnCollections.length > 0 && (
          <Organism1 subCollections={columnCollections} publisherAttributes={publisherAttributes} />
        )}
        <div className="collection-wrapper">
          {showSubCollectionName && (
            <Link href={fourthCollectionSlug}>
              <Headline
                text={fourthCollection.name}
                headlineType={21}
                headerLevel={2}
                className={`first-collection-name ${
                  publisherAttributes.lang === "en" ? "en-first-collection-name" : ""
                }`}
              />
            </Link>
          )}
          <div styleName="collection-story-wrapper">
            <div>
              <div styleName="big-story" className="big-story-cards">
                {storyList.length > 0 && (
                  <WideStoryCard
                    story={storyList[0].story}
                    widths={global.deviceWidth < 876 ? [350] : [620]}
                    updatedFont={true}
                    src="four-collection-12-stories-1-ad"
                  />
                )}
              </div>
              {storyList.length > 1 && (
                <div styleName="medium-story" className="medium-story-cards">
                  <Organism2
                    storyList={storyList.slice(1, 3)}
                    updatedFont={true}
                    publisherLang={publisherAttributes.lang}
                  />
                </div>
              )}
            </div>
            <div>
              <div styleName={isTab ? "ad-slot-728x90" : "ad-slot-300x250"}>
                <DfpAd
                  adtype={publisherAttributes.lang === "en" ? "EnPalo_HP_336x280_R2" : "Home_336x280_R2"}
                  collectionSlug={collectionSlug}
                  layoutName="FourCollection12Stories1Ad"
                />
              </div>
              {storyList.length > 3 && (
                <div styleName={isTab ? "tab-small-story" : "small-story"} className="small-story-cards">
                  {storyList.slice(3, 6).map(({ story }, index) => (
                    <CustomStoryCard4
                      story={story}
                      headlineType={16}
                      showStoryMetaInfo={false}
                      key={index}
                      updatedFont={true}
                      src="four-collection-12-stories-1-ad"
                    />
                  ))}
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

FourCollection12Stories1Ad.propTypes = {
  collection: object,
  sections: array,
  publisherAttributes: object,
  domainSlug: string
};

const mapStateToProps = state => {
  return {
    sections: get(state, ["qt", "config", "sections"], []),
    publisherAttributes: get(state, ["qt", "config", "publisher-attributes"], {}),
    domainSlug: get(state, ["qt", "config", "domainSlug"], "")
  };
};

export default connect(mapStateToProps, null)(FourCollection12Stories1Ad);
